const normalizeAdminPath = (path) => {
  if (!path || typeof path !== 'string') {
    return '/cd-admin';
  }

  return path.startsWith('/') ? path : `/${path}`;
};

export const ADMIN_PATH = normalizeAdminPath(process.env.REACT_APP_ADMIN_PATH);


